import {
  getAdjustedDate,
  getFormattedDate,
} from "../../../../../../legacyComponents/util/helperFunctions";
import { formatDate } from "../../../../../../legacyComponents/util/formating";
import { options } from ".";
import { MAX_BENEFIT_AGE_LIST } from "../../../../../../legacyComponents/util/api/apis/employer/PermissibleClass/constants";

export default function getInitialValues(employerPlan, permissibleClass) {
  // console.log("In getInitialValues with employerPlan:", employerPlan);
  // console.log("In getInitialValues and permissibleClass:", permissibleClass);
  if (!employerPlan) {
    // console.log("No user or no employerAdminEmployer, returning empty initial values.");
    return {
      newPlan: "",
    };
  }
  const dateOptions = { month: "long", year: "numeric" };

  const results = {
    movedPlan: (() => {
      const movedPlan = employerPlan?.movedPlan;

      if (movedPlan) return "Yes";
      else if (movedPlan === false) return "No";
    })(),

    midYearPlan: (() => {
      const midYearPlan = employerPlan?.midYearPlan;

      if (midYearPlan) return "1";
      else if (midYearPlan === false) return "0";
      else return "";
    })(),

    startDate: (() => {
      const startDate = employerPlan?.startDate;

      if (startDate) {
        const display = getFormattedDate({
          date: startDate,
          options: dateOptions,
        });
        const value = getAdjustedDate({ date: startDate });
        const dateString = formatDate({ data: value, actions: ["mysql"] });

        return { display, value, dateString };
      } else {
        return options.nullDateOption();
      }
    })(),

    endDate: (() => {
      const endDate = employerPlan?.endDate;

      if (endDate) {
        const display = getFormattedDate({
          date: endDate,
          options: dateOptions,
        });
        const value = getAdjustedDate({ date: endDate });
        const dateString = formatDate({ data: value, actions: ["mysql"] });

        return { display, value, dateString };
      } else {
        return options.nullDateOption();
      }
    })(),

    allowTextSubmission: (() => {
      if (employerPlan?.allowTextSubmission) return "Yes";
      else if (employerPlan?.allowTextSubmission === false) return "No";
      else return "";
    })(),
    // No longer collected. Always sent as 0 so the payload shape is unchanged.
    textSubmissionDays: 0,

    reimbursementMethod: (() => {
      let reimbursementMethod = employerPlan?.reimbursementDistributionMethod;
      reimbursementMethod = options.reimbursementMethods.find(
        ({ value }) => value === reimbursementMethod,
      );

      return reimbursementMethod || options.nullOption();
    })(),

    reimbursementTiming: (() => {
      // Report schedules live in reportTimings, not reimbursementTimings.
      // Searching only the ACH list dropped SEMI_MONTHLY entirely and
      // resolved MONTHLY to the wrong option object.
      const list =
        employerPlan?.reimbursementDistributionMethod === "SALUSION"
          ? options.reimbursementTimings
          : options.reportTimings;
      const saved = employerPlan?.reimbursementDistributionTiming;

      return list.find(({ value }) => value === saved) || options.nullOption();
    })(),

    reimbursementDay: (() => {
      const reimbursementDay =
        employerPlan?.reimbursementDistributionDayOfMonth;

      if (reimbursementDay) return reimbursementDay?.toString();
      else return "";
    })(),
    predefinedClasses: (() => {
      const predefinedClasses = permissibleClass?.predefinedClasses;

      if (predefinedClasses?.length) {
        return predefinedClasses?.reduce(
          (predefinedClasses, { type, isExcluded }) => {
            predefinedClasses[type] = !isExcluded;
            return predefinedClasses;
          },
          {},
        );
      } else {
        return {};
      }
    })(),
    excludedClasses: (() => {
      const predefinedClasses = permissibleClass?.predefinedClasses;

      if (predefinedClasses?.length) {
        return predefinedClasses?.reduce(
          (predefinedClasses, { type, isExcluded }) => {
            // console.log("type =", type, "isExcluded =", isExcluded)
            predefinedClasses[type] = isExcluded;
            return predefinedClasses;
          },
          {},
        );
      } else {
        return {};
      }
    })(),

    ratingAreas: (() => {
      return permissibleClass?.predefinedClasses
        ?.find(({ type }) => type === "RATING")
        ?.states?.reduce((states, state) => {
          states[state] = true;
          return states;
        }, {});
    })(),

    otherRatingArea: (() => {
      const otherRatingArea = permissibleClass?.predefinedClasses?.find(
        ({ type }) => type === "RATING",
      );
      return otherRatingArea?.other || "";
    })(),

    qualifiedBenefits: (() => {
      const qualifiedBenefits = permissibleClass?.qualifiedBenefits;

      if (qualifiedBenefits) {
        return qualifiedBenefits?.reduce((qualifiedBenefits, { type }) => {
          qualifiedBenefits[type] = true;
          return qualifiedBenefits;
        }, {});
      } else {
        return {};
      }
    })(),

    otherBenefit: (() => {
      const otherBenefit = permissibleClass?.qualifiedBenefits?.find(
        ({ type }) => type === "OTHER",
      );
      return otherBenefit?.description || "";
    })(),

    maxBenefit: (() => {
      const maxBenefit = permissibleClass?.maxBenefit?.type;

      if (maxBenefit) return { [maxBenefit]: true };
      else return {};
    })(),
    maxBenefit_required: (() => {
      const maxBenefit = permissibleClass?.maxBenefit?.type;
      return maxBenefit ? "yes" : "";
    })(),
    age_qualify: (() => {
      // Will be set by useEffect in Allowance component based on age table validation
      return "";
    })(),

    ...(() => {
      const selfAmount =
        permissibleClass?.maxBenefit?.SELF?.amount / 1200 || "";
      const amounts = { selfAmount };

      for (
        let age = MAX_BENEFIT_AGE_LIST.MINIMUM_AGE;
        age <= MAX_BENEFIT_AGE_LIST.MAXIMUM_AGE;
        age++
      ) {
        const key = `amount${age}`;
        const formKey = `selfAmount${age}`;

        amounts[formKey] = permissibleClass?.maxBenefit?.SELF?.[key] || "";
      }

      return amounts;
    })(),

    ...(() => {
      const spouseAmount =
        permissibleClass?.maxBenefit?.SPOUSE?.amount / 1200 || "";
      const amounts = { spouseAmount };

      for (
        let age = MAX_BENEFIT_AGE_LIST.MINIMUM_AGE;
        age <= MAX_BENEFIT_AGE_LIST.MAXIMUM_AGE;
        age++
      ) {
        const key = `amount${age}`;
        const formKey = `spouseAmount${age}`;

        amounts[formKey] = permissibleClass?.maxBenefit?.SPOUSE?.[key] || "";
      }

      return amounts;
    })(),

    ...(() => {
      const childAmount =
        permissibleClass?.maxBenefit?.CHILDREN?.amount / 1200 || "";
      const amounts = { childAmount };

      for (
        let age = MAX_BENEFIT_AGE_LIST.MINIMUM_AGE;
        age <= MAX_BENEFIT_AGE_LIST.MAXIMUM_AGE;
        age++
      ) {
        const key = `amount${age}`;
        const formKey = `childAmount${age}`;

        amounts[formKey] = permissibleClass?.maxBenefit?.CHILDREN?.[key] || "";
      }

      return amounts;
    })(),

    ...(() => {
      const allAmount =
        permissibleClass?.maxBenefit?.SPOUSE_CHILDREN?.amount / 1200 || "";
      const amounts = { allAmount };

      for (
        let age = MAX_BENEFIT_AGE_LIST.MINIMUM_AGE;
        age <= MAX_BENEFIT_AGE_LIST.MAXIMUM_AGE;
        age++
      ) {
        const key = `amount${age}`;
        const formKey = `allAmount${age}`;

        amounts[formKey] =
          permissibleClass?.maxBenefit?.SPOUSE_CHILDREN?.[key] || "";
      }

      return amounts;
    })(),

    acaCalculation: (() => {
      const useAcaSalary = permissibleClass?.useAcaSalary;

      if (useAcaSalary) return { SALARY: true };
      else if (useAcaSalary === false) return { FEDERAL: true };
      else return {};
    })(),
    acaSalary: permissibleClass?.v2
      ? permissibleClass?.acaSalary
        ? permissibleClass?.acaSalary
        : null
      : permissibleClass?.acaSalary,
    useAcaSalary: permissibleClass?.useAcaSalary || false,
    acaMultipleSelf: permissibleClass?.acaMultipleSelf || 100,
    acaMultipleSpouse: permissibleClass?.acaMultipleSpouse || 100,
    acaMultipleChildren: permissibleClass?.acaMultipleChildren || 100,
    acaMultipleSpouseChildren:
      permissibleClass?.acaMultipleSpouseChildren || 100,
    acaAdjustmentType: permissibleClass?.acaAdjustmentType || "SELF",
    acaAdditionSelf: permissibleClass?.acaAdditionSelf || 0,
    acaAdditionSpouse: permissibleClass?.acaAdditionSpouse || 0,
    acaAdditionChildren: permissibleClass?.acaAdditionChildren || 0,
    acaAdditionSpouseChildren: permissibleClass?.acaAdditionSpouseChildren || 0,
    v2: permissibleClass?.v2 || false,
    monthlySelfAmount: permissibleClass?.monthlySelfAmount
      ? (permissibleClass?.monthlySelfAmount || 0) / 100
      : "",
    monthlyFirstDependentAmount: permissibleClass?.monthlyFirstDependentAmount
      ? (permissibleClass?.monthlyFirstDependentAmount || 0) / 100
      : "",
    monthlyAdditionalDependentAmount:
      permissibleClass?.monthlyAdditionalDependentAmount
        ? (permissibleClass?.monthlyAdditionalDependentAmount || 0) / 100
        : "",
    eligibleIndividuals: permissibleClass?.eligibleIndividuals
      ? { [permissibleClass.eligibleIndividuals]: true }
      : {},
    allowanceMethod:
      permissibleClass?.allowanceMethod !== null
        ? { [permissibleClass?.allowanceMethod]: true }
        : {},
    allowanceMethod_required:
      permissibleClass?.allowanceMethod !== null ? "yes" : "",
    metalLevel: permissibleClass?.metalLevel || "BRONZE",
    metalPercent: permissibleClass?.metalPercent || "",
    // Radio object for AllowanceType: { true: true } = omit the ACA minimum,
    // { false: true } = apply it. Null on the class means "apply", the backend default.
    metalOmitAcaAffordability:
      permissibleClass?.metalOmitAcaAffordability === true
        ? { true: true }
        : { false: true },
    metalV2: permissibleClass?.metalV2 || false,
    metalPercentDependent: permissibleClass?.metalPercentDependent ?? "",
    group_error: "",
  };
  // console.log("getInitialValues returning:", results);
  return results;
}
